import React from 'react'
import Button from './Button'

const ButtonList = () => {
  return (
    <div className="flex justify-center">
      <Button name="News"/>
      <Button name="Mixes"/>
      <Button name="Music"/>
      <Button name="Live"/>
      <Button name="Computer programing"/>
      <Button name="Cricket"/>
      <Button name="Development"/>
      <Button name="UnWatched"/>
      <Button name="Dhruv Rathe"/>
      <Button name="Olympics"/>

      
    </div>
  )
}

export default ButtonList
